var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"two-step-container"},[_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"offset-md-1 col-md-6 px-0"},[_c('two-step-instructions')],1),_c('div',{staticClass:"col-md-5 px-0 faq-container"},[_c('two-step-faq')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }